export default "__VITE_ASSET__543ae0c5__"